

// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import { 
// //   Badge, 
// //   Table, 
// //   Spinner, 
// //   Container, 
// //   Button, 
// //   Alert, 
// //   Modal, 
// //   Form,
// //   Row,
// //   Col,
// //   InputGroup,
// //   FormControl
// // } from 'react-bootstrap';
// // import config from '../../Common/Configurations/APIConfig';
// // import DefaultData from '../../Common/CompanyData/DefaultData';

// // function AdminOrders() {
// //     const [orders, setOrders] = useState([]);
// //     const [filteredOrders, setFilteredOrders] = useState([]);
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState('');
// //     const [success, setSuccess] = useState('');
    
// //     // Filter states
// //     const [searchTerm, setSearchTerm] = useState('');
// //     const [selectedStatus, setSelectedStatus] = useState('all');
// //     const [dateFilter, setDateFilter] = useState('');
// //     const [orderNoFilter, setOrderNoFilter] = useState('');
    
// //     // Modal states
// //     const [showDetailsModal, setShowDetailsModal] = useState(false);
// //     const [showItemsModal, setShowItemsModal] = useState(false); 
// //     const [selectedOrder, setSelectedOrder] = useState(null);
// //     const [showCancelModal, setShowCancelModal] = useState(false);
// //     const [orderToCancel, setOrderToCancel] = useState(null);
// //     const [showEditModal, setShowEditModal] = useState(false);
// //     const [editForm, setEditForm] = useState({ orderId: '', status: '', shippingAddress: '', notes: '' });
// //     const [btnLoading, setBtnLoading] = useState(false);

// //     const THEME_COLOR = '#065f46';
// //     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';
// //     const defaultStatusOptions = ['Order Placed', 'Confirmed', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];

// //     useEffect(() => { fetchOrders(); }, []);
// //     useEffect(() => { applyFilters(); }, [orders, searchTerm, selectedStatus, dateFilter, orderNoFilter]);

// //     const fetchOrders = async () => {
// //         try {
// //             setLoading(true);
// //             const res = await axios.get(config.APIACTIVEURL + config.GETALLORDERS);
// //             let ordersData = res.data?.data || res.data || [];
// //             ordersData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
// //             setOrders(ordersData);
// //         } catch (err) { 
// //             console.error("Fetch Error", err);
// //             setError('Failed to load orders.'); 
// //         } finally { setLoading(false); }
// //     };

// //     const applyFilters = () => {
// //         let filtered = [...orders];
// //         if (searchTerm) {
// //             const term = searchTerm.toLowerCase();
// //             filtered = filtered.filter(o => 
// //                 (o.orderNo?.toLowerCase().includes(term)) ||
// //                 (o.customerName?.toLowerCase().includes(term)) ||
// //                 (o.user?.name?.toLowerCase().includes(term))
// //             );
// //         }
// //         if (selectedStatus !== 'all') {
// //             filtered = filtered.filter(o => o.status?.toLowerCase() === selectedStatus.toLowerCase());
// //         }
// //         if (dateFilter) {
// //             filtered = filtered.filter(o => o.createdAt && o.createdAt.startsWith(dateFilter));
// //         }
// //         if (orderNoFilter) {
// //             filtered = filtered.filter(o => o.orderNo?.toLowerCase().includes(orderNoFilter.toLowerCase()));
// //         }
// //         setFilteredOrders(filtered);
// //     };

// //     const clearFilters = () => {
// //         setSearchTerm('');
// //         setSelectedStatus('all');
// //         setDateFilter('');
// //         setOrderNoFilter('');
// //     };

// //     const formatDate = (dateString) => {
// //         if (!dateString) return '-';
// //         const cleanDate = dateString.replace('Z', '').split('.')[0];
// //         const date = new Date(cleanDate);
// //         return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
// //     };

// //     const formatTime = (dateString) => {
// //         if (!dateString) return '-';
// //         const cleanDate = dateString.replace('Z', '').split('.')[0];
// //         const date = new Date(cleanDate);
// //         return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
// //     };

// //     const getStatusColor = (status) => {
// //         const s = status?.toLowerCase();
// //         if (s === 'order placed') return 'warning';
// //         if (['confirmed', 'processing', 'shipped'].includes(s)) return 'info';
// //         if (['delivered', 'completed'].includes(s)) return 'success';
// //         if (['cancelled', 'rejected'].includes(s)) return 'danger';
// //         return 'secondary';
// //     };

// //     const handleSaveEdit = async () => {
// //         try {
// //             setBtnLoading(true);
// //             const res = await axios.put(`${config.APIACTIVEURL}${config.UPDATEORDERSTATUS}/${editForm.orderId}?status=${editForm.status}`, editForm);
// //             if (res.data.success) {
// //                 setOrders(orders.map(o => o.orderId === editForm.orderId ? { ...o, ...editForm } : o));
// //                 setShowEditModal(false);
// //                 setSuccess('Order updated successfully!');
// //                 setTimeout(() => setSuccess(''), 3000);
// //             }
// //         } catch (error) { setError('Failed to update order.'); }
// //         finally { setBtnLoading(false); }
// //     };

// //     const confirmCancel = async () => {
// //         if (!orderToCancel) return;
// //         try {
// //             setBtnLoading(true);
// //             const res = await axios.post(`${config.APIACTIVEURL}Orders/cancel/${orderToCancel.orderNo}`);
// //             if (res.data.success) {
// //                 setOrders(orders.map(o => o.orderId === orderToCancel.orderId ? { ...o, status: 'Cancelled' } : o));
// //                 setSuccess('Order cancelled successfully!');
// //             }
// //             setShowCancelModal(false);
// //             setTimeout(() => setSuccess(''), 3000);
// //         } catch (error) { setError('Failed to cancel order.'); }
// //         finally { setBtnLoading(false); }
// //     };

// //     const formatCurrency = (amount) => `${currency} ${parseFloat(amount || 0).toFixed(2)}`;

// //     return (
// //         <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingTop: '100px' }}>
// //             <Container fluid className="px-4">
// //                 {/* --- TOP HEADER --- */}
// //                 <div className="d-flex justify-content-between align-items-center mb-4">
// //                     <h2 className="fw-bold text-dark mb-0">Orders Management</h2>
// //                     <div className="d-flex gap-2">
// //                         <Badge bg="light" text="dark" className="px-3 py-2 border d-flex align-items-center">
// //                             {filteredOrders.length} of {orders.length} Orders
// //                         </Badge>
// //                         <Button variant="danger" onClick={clearFilters}>
// //                             <i className="ri-filter-off-line me-2"></i> Clear Filters
// //                         </Button>
// //                     </div>
// //                 </div>

// //                 {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}
// //                 {success && <Alert variant="success" dismissible onClose={() => setSuccess('')}>{success}</Alert>}

// //                 {/* --- FILTERS SECTION --- */}
// //                 <div className="card border-0 shadow-sm mb-4 rounded-4">
// //                     <div className="card-body p-4">
// //                         <Row className="g-3">
// //                             <Col md={3}>
// //                                 <Form.Label className="small fw-bold">Order Number</Form.Label>
// //                                 <FormControl placeholder="OR123..." value={orderNoFilter} onChange={e => setOrderNoFilter(e.target.value)} />
// //                             </Col>
// //                             <Col md={3}>
// //                                 <Form.Label className="small fw-bold">Search Customer/Product</Form.Label>
// //                                 <FormControl placeholder="Name or Email..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
// //                             </Col>
// //                             <Col md={3}>
// //                                 <Form.Label className="small fw-bold">Status</Form.Label>
// //                                 <Form.Select value={selectedStatus} onChange={e => setSelectedStatus(e.target.value)}>
// //                                     <option value="all">All Status</option>
// //                                     {defaultStatusOptions.map(s => <option key={s} value={s}>{s}</option>)}
// //                                 </Form.Select>
// //                             </Col>
// //                             <Col md={3}>
// //                                 <Form.Label className="small fw-bold">Order Date</Form.Label>
// //                                 <Form.Control type="date" value={dateFilter} onChange={e => setDateFilter(e.target.value)} />
// //                             </Col>
// //                         </Row>

// //                         {/* --- ACTIVE BADGES --- */}
// //                         {(searchTerm || selectedStatus !== 'all' || dateFilter || orderNoFilter) && (
// //                             <div className="d-flex gap-2 mt-3 flex-wrap">
// //                                 {orderNoFilter && <Badge bg="primary">No: {orderNoFilter}</Badge>}
// //                                 {selectedStatus !== 'all' && <Badge bg="info">Status: {selectedStatus}</Badge>}
// //                                 {dateFilter && <Badge bg="secondary">Date: {dateFilter}</Badge>}
// //                                 {searchTerm && <Badge bg="dark">Search: {searchTerm}</Badge>}
// //                             </div>
// //                         )}
// //                     </div>
// //                 </div>

// //                 {/* --- MAIN TABLE --- */}
// //                 <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
// //                     <div className="table-responsive">
// //                         <Table hover className="align-middle mb-0">
// //                             <thead className="table-light">
// //                                 <tr className="text-uppercase small text-muted">
// //                                     <th className="ps-4 py-3">Order No</th>
// //                                     <th>Customer</th>
// //                                     <th>Total</th>
// //                                     <th>Status</th>
// //                                     <th>Date</th>
// //                                     <th className="text-center">Actions</th>
// //                                 </tr>
// //                             </thead>
// //                             <tbody>
// //                                 {loading && orders.length === 0 ? (
// //                                     <tr><td colSpan="6" className="text-center py-5"><Spinner animation="border" /></td></tr>
// //                                 ) : filteredOrders.map(order => (
// //                                     <tr key={order.orderId}>
// //                                         <td className="ps-4 fw-bold text-primary">{order.orderNo}</td>
// //                                         <td>
// //                                             <div className="fw-bold">{order.customerName || order.user?.name}</div>
// //                                             <div className="small text-muted">{order.user?.phoneNumber || 'No Phone'}</div>
// //                                         </td>
// //                                         <td className="fw-bold text-success">{formatCurrency(order.totalAmount)}</td>
// //                                         <td><Badge bg={getStatusColor(order.status)}>{order.status}</Badge></td>
// //                                         <td>
// //                                             <div className="fw-bold">{formatDate(order.createdAt)}</div>
// //                                             <small className="text-muted">{formatTime(order.createdAt)}</small>
// //                                         </td>
// //                                         <td className="text-center">
// //                                             <div className="d-flex justify-content-center gap-1">
// //                                                 <Button variant="link" className="text-success p-1" title="Items" onClick={() => { setSelectedOrder(order); setShowItemsModal(true); }}>
// //                                                     <i className="ri-list-check-2 fs-4"></i>
// //                                                 </Button>
// //                                                 <Button variant="link" className="text-primary p-1" title="Customer" onClick={() => { setSelectedOrder(order); setShowDetailsModal(true); }}>
// //                                                     <i className="ri-user-search-line fs-4"></i>
// //                                                 </Button>
// //                                                 <Button variant="link" className="text-warning p-1" onClick={() => {
// //                                                     setEditForm({ orderId: order.orderId, status: order.status, shippingAddress: order.shippingAddress, notes: order.notes });
// //                                                     setShowEditModal(true);
// //                                                 }}>
// //                                                     <i className="ri-pencil-line fs-4"></i>
// //                                                 </Button>
// //                                                 <Button variant="link" className="text-danger p-1" onClick={() => { setOrderToCancel(order); setShowCancelModal(true); }}>
// //                                                     <i className="ri-close-circle-line fs-4"></i>
// //                                                 </Button>
// //                                             </div>
// //                                         </td>
// //                                     </tr>
// //                                 ))}
// //                             </tbody>
// //                         </Table>
// //                     </div>
// //                 </div>
// //             </Container>

// //             {/* --- MODAL: ORDER ITEMS --- */}
// //             <Modal show={showItemsModal} onHide={() => setShowItemsModal(false)} size="lg" centered>
// //                 <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Items for {selectedOrder?.orderNo}</Modal.Title></Modal.Header>
// //                 <Modal.Body className="p-0">
// //                     <Table responsive hover className="mb-0">
// //                         <thead className="bg-light small text-uppercase">
// //                             <tr><th className="ps-4">Product</th><th className="text-center">Price</th><th className="text-center">Qty</th><th className="text-end pe-4">Subtotal</th></tr>
// //                         </thead>
// //                         <tbody>
// //                             {selectedOrder?.orderItems?.map((item, idx) => (
// //                                 <tr key={idx}>
// //                                     <td className="ps-4"><strong>{item.product?.productName}</strong><br/><small className="text-muted">{item.product?.category}</small></td>
// //                                     <td className="text-center">{formatCurrency(item.unitPrice)}</td>
// //                                     <td className="text-center">x {item.quantity}</td>
// //                                     <td className="text-end pe-4 fw-bold text-success">{formatCurrency(item.unitPrice * item.quantity)}</td>
// //                                 </tr>
// //                             ))}
// //                         </tbody>
// //                         <tfoot className="table-light fw-bold">
// //                             <tr><td colSpan="3" className="text-end ps-4">Total Amount:</td><td className="text-end pe-4 text-success" style={{ fontSize: '1.2rem' }}>{formatCurrency(selectedOrder?.totalAmount)}</td></tr>
// //                         </tfoot>
// //                     </Table>
// //                 </Modal.Body>
// //                 <Modal.Footer className="border-0"><Button variant="secondary" onClick={() => setShowItemsModal(false)}>Close</Button></Modal.Footer>
// //             </Modal>

// //             {/* --- MODAL: CUSTOMER INFO --- */}
// //             <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
// //                 <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Customer Details</Modal.Title></Modal.Header>
// //                 <Modal.Body className="bg-light mx-3 rounded-3 p-4">
// //                     <div className="mb-3"><small className="text-muted d-block fw-bold">NAME</small><strong>{selectedOrder?.customerName || selectedOrder?.user?.name}</strong></div>
// //                     <div className="mb-3"><small className="text-muted d-block fw-bold">EMAIL</small><strong>{selectedOrder?.user?.email || selectedOrder?.email}</strong></div>
// //                     <div className="mb-3"><small className="text-muted d-block fw-bold">PHONE</small><strong className="text-primary">{selectedOrder?.user?.phoneNumber || selectedOrder?.customerPhone || selectedOrder?.phoneNumber || 'N/A'}</strong></div>
// //                     <div className="mb-0"><small className="text-muted d-block fw-bold">SHIPPING ADDRESS</small><strong>{selectedOrder?.shippingAddress || 'N/A'}</strong></div>
// //                 </Modal.Body>
// //                 <Modal.Footer className="border-0"><Button variant="secondary" onClick={() => setShowDetailsModal(false)}>Close</Button></Modal.Footer>
// //             </Modal>

// //             {/* --- MODAL: EDIT STATUS --- */}
// //             <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
// //                 <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Update Order</Modal.Title></Modal.Header>
// //                 <Modal.Body>
// //                     <Form.Group className="mb-3"><Form.Label className="small fw-bold">Status</Form.Label>
// //                         <Form.Select value={editForm.status} onChange={e => setEditForm({...editForm, status: e.target.value})}>{defaultStatusOptions.map(s => <option key={s} value={s}>{s}</option>)}</Form.Select>
// //                     </Form.Group>
// //                     <Form.Group><Form.Label className="small fw-bold">Shipping Address</Form.Label>
// //                         <Form.Control as="textarea" rows={2} value={editForm.shippingAddress} onChange={e => setEditForm({...editForm, shippingAddress: e.target.value})} />
// //                     </Form.Group>
// //                 </Modal.Body>
// //                 <Modal.Footer className="border-0"><Button variant="primary" onClick={handleSaveEdit} className="w-100" style={{ backgroundColor: THEME_COLOR }}>Save Changes</Button></Modal.Footer>
// //             </Modal>

// //             {/* --- MODAL: CANCEL --- */}
// //             <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered>
// //                 <Modal.Body className="text-center p-4">
// //                     <h5 className="text-danger fw-bold">Cancel Order?</h5>
// //                     <p>Are you sure you want to cancel <strong>{orderToCancel?.orderNo}</strong>?</p>
// //                     <div className="d-grid gap-2"><Button variant="danger" onClick={confirmCancel} disabled={btnLoading}>{btnLoading ? 'Cancelling...' : 'Confirm Cancellation'}</Button><Button variant="light" onClick={() => setShowCancelModal(false)}>Keep Order</Button></div>
// //                 </Modal.Body>
// //             </Modal>
// //         </div>
// //     );
// // }

// // export default AdminOrders;

// // web view 






import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Badge,
  Table,
  Spinner,
  Container,
  Button,
  Alert,
  Modal,
  Form,
  Row,
  Col,
  FormControl
} from 'react-bootstrap';
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

function AdminOrders() {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('all');
    const [dateFilter, setDateFilter] = useState('');
    const [orderNoFilter, setOrderNoFilter] = useState('');

    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [orderToCancel, setOrderToCancel] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editForm, setEditForm] = useState({ orderId: '', status: '', shippingAddress: '', notes: '' });
    const [btnLoading, setBtnLoading] = useState(false);

    const THEME_COLOR = '#065f46';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';
    const defaultStatusOptions = ['Order Placed', 'Confirmed', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];

    useEffect(() => { fetchOrders(); }, []);
    useEffect(() => { applyFilters(); }, [orders, searchTerm, selectedStatus, dateFilter, orderNoFilter]);

    const fetchOrders = async () => {
        try {
            setLoading(true);
            const res = await axios.get(config.APIACTIVEURL + config.GETALLORDERS);
            let ordersData = res.data?.data || res.data || [];
            ordersData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setOrders(ordersData);
        } catch (err) {
            console.error("Fetch Error", err);
            setError('Failed to load orders.');
        } finally { setLoading(false); }
    };

    const applyFilters = () => {
        let filtered = [...orders];
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(o =>
                (o.orderNo?.toLowerCase().includes(term)) ||
                (o.customerName?.toLowerCase().includes(term)) ||
                (o.user?.name?.toLowerCase().includes(term))
            );
        }
        if (selectedStatus !== 'all') {
            filtered = filtered.filter(o => o.status?.toLowerCase() === selectedStatus.toLowerCase());
        }
        if (dateFilter) {
            filtered = filtered.filter(o => o.createdAt && o.createdAt.startsWith(dateFilter));
        }
        if (orderNoFilter) {
            filtered = filtered.filter(o => o.orderNo?.toLowerCase().includes(orderNoFilter.toLowerCase()));
        }
        setFilteredOrders(filtered);
    };

    const clearFilters = () => {
        setSearchTerm('');
        setSelectedStatus('all');
        setDateFilter('');
        setOrderNoFilter('');
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const cleanDate = dateString.replace('Z', '').split('.')[0];
        const date = new Date(cleanDate);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const formatTime = (dateString) => {
        if (!dateString) return '-';
        const cleanDate = dateString.replace('Z', '').split('.')[0];
        const date = new Date(cleanDate);
        return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const getStatusColor = (status) => {
        const s = status?.toLowerCase();
        if (s === 'order placed') return 'warning';
        if (['confirmed', 'processing', 'shipped'].includes(s)) return 'info';
        if (['delivered', 'completed'].includes(s)) return 'success';
        if (['cancelled', 'rejected'].includes(s)) return 'danger';
        return 'secondary';
    };

    const handleSaveEdit = async () => {
        try {
            setBtnLoading(true);
            const res = await axios.put(`${config.APIACTIVEURL}${config.UPDATEORDERSTATUS}/${editForm.orderId}?status=${editForm.status}`, editForm);
            if (res.data.success) {
                setOrders(orders.map(o => o.orderId === editForm.orderId ? { ...o, ...editForm } : o));
                setShowEditModal(false);
                setSuccess('Order updated successfully!');
                setTimeout(() => setSuccess(''), 3000);
            }
        } catch (error) { setError('Failed to update order.'); }
        finally { setBtnLoading(false); }
    };

    const confirmCancel = async () => {
        if (!orderToCancel) return;
        try {
            setBtnLoading(true);
            const res = await axios.post(`${config.APIACTIVEURL}Orders/cancel/${orderToCancel.orderNo}`);
            if (res.data.success) {
                setOrders(orders.map(o => o.orderId === orderToCancel.orderId ? { ...o, status: 'Cancelled' } : o));
                setSuccess('Order cancelled successfully!');
            }
            setShowCancelModal(false);
            setTimeout(() => setSuccess(''), 3000);
        } catch (error) { setError('Failed to cancel order.'); }
        finally { setBtnLoading(false); }
    };

    const formatCurrency = (amount) => `${currency} ${parseFloat(amount || 0).toFixed(2)}`;

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingTop: '100px' }}>
            <Container fluid className="px-3 px-md-4">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                    <h2 className="fw-bold text-dark mb-3 mb-md-0">Orders Management</h2>
                    <div className="d-flex gap-2">
                        <Badge bg="light" text="dark" className="px-3 py-2 border d-flex align-items-center">
                            {filteredOrders.length} of {orders.length} Orders
                        </Badge>
                        <Button variant="danger" onClick={clearFilters}>
                            <i className="ri-filter-off-line me-2"></i> Clear Filters
                        </Button>
                    </div>
                </div>

                {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}
                {success && <Alert variant="success" dismissible onClose={() => setSuccess('')}>{success}</Alert>}

                <div className="card border-0 shadow-sm mb-4 rounded-4">
                    <div className="card-body p-4">
                        <Row className="g-3">
                            <Col xs={12} md={3}>
                                <Form.Label className="small fw-bold">Order Number</Form.Label>
                                <FormControl placeholder="OR123..." value={orderNoFilter} onChange={e => setOrderNoFilter(e.target.value)} />
                            </Col>
                            <Col xs={12} md={3}>
                                <Form.Label className="small fw-bold">Search Customer/Product</Form.Label>
                                <FormControl placeholder="Name or Email..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                            </Col>
                            <Col xs={12} md={3}>
                                <Form.Label className="small fw-bold">Status</Form.Label>
                                <Form.Select value={selectedStatus} onChange={e => setSelectedStatus(e.target.value)}>
                                    <option value="all">All Status</option>
                                    {defaultStatusOptions.map(s => <option key={s} value={s}>{s}</option>)}
                                </Form.Select>
                            </Col>
                            <Col xs={12} md={3}>
                                <Form.Label className="small fw-bold">Order Date</Form.Label>
                                <Form.Control type="date" value={dateFilter} onChange={e => setDateFilter(e.target.value)} />
                            </Col>
                        </Row>

                        {(searchTerm || selectedStatus !== 'all' || dateFilter || orderNoFilter) && (
                            <div className="d-flex gap-2 mt-3 flex-wrap">
                                {orderNoFilter && <Badge bg="primary">No: {orderNoFilter}</Badge>}
                                {selectedStatus !== 'all' && <Badge bg="info">Status: {selectedStatus}</Badge>}
                                {dateFilter && <Badge bg="secondary">Date: {dateFilter}</Badge>}
                                {searchTerm && <Badge bg="dark">Search: {searchTerm}</Badge>}
                            </div>
                        )}
                    </div>
                </div>

                <div className="d-none d-md-block card border-0 shadow-sm rounded-4 overflow-hidden">
                    <div className="table-responsive">
                        <Table hover className="align-middle mb-0">
                            <thead className="table-light">
                                <tr className="text-uppercase small text-muted">
                                    <th className="ps-4 py-3">Order No</th>
                                    <th>Customer</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && orders.length === 0 ? (
                                    <tr><td colSpan="6" className="text-center py-5"><Spinner animation="border" /></td></tr>
                                ) : filteredOrders.map(order => (
                                    <tr key={order.orderId}>
                                        <td className="ps-4 fw-bold text-primary">{order.orderNo}</td>
                                        <td>
                                            <div className="fw-bold">{order.customerName || order.user?.name}</div>
                                            <div className="small text-muted">{order.user?.phoneNumber || 'No Phone'}</div>
                                        </td>
                                        <td className="fw-bold text-success">{formatCurrency(order.totalAmount)}</td>
                                        <td><Badge bg={getStatusColor(order.status)}>{order.status}</Badge></td>
                                        <td>
                                            <div className="fw-bold">{formatDate(order.createdAt)}</div>
                                            <small className="text-muted">{formatTime(order.createdAt)}</small>
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center gap-1">
                                                <Button variant="link" className="text-success p-1" title="Items" onClick={() => { setSelectedOrder(order); setShowItemsModal(true); }}>
                                                    <i className="ri-list-check-2 fs-4"></i>
                                                </Button>
                                                <Button variant="link" className="text-primary p-1" title="Customer" onClick={() => { setSelectedOrder(order); setShowDetailsModal(true); }}>
                                                    <i className="ri-user-search-line fs-4"></i>
                                                </Button>
                                                <Button variant="link" className="text-warning p-1" onClick={() => {
                                                    setEditForm({ orderId: order.orderId, status: order.status, shippingAddress: order.shippingAddress, notes: order.notes });
                                                    setShowEditModal(true);
                                                }}>
                                                    <i className="ri-pencil-line fs-4"></i>
                                                </Button>
                                                <Button variant="link" className="text-danger p-1" onClick={() => { setOrderToCancel(order); setShowCancelModal(true); }}>
                                                    <i className="ri-close-circle-line fs-4"></i>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>

                <div className="d-md-none">
                    {loading && orders.length === 0 ? (
                        <div className="text-center py-5"><Spinner animation="border" /></div>
                    ) : filteredOrders.map(order => (
                        <div key={order.orderId} className="card border-0 shadow-sm rounded-4 mb-3">
                            <div className="card-body p-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fw-bold text-primary">{order.orderNo}</span>
                                    <Badge bg={getStatusColor(order.status)}>{order.status}</Badge>
                                </div>
                                <div className="mb-2">
                                    <div className="fw-bold">{order.customerName || order.user?.name}</div>
                                    <div className="small text-muted">{order.user?.phoneNumber || 'No Phone'}</div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <div className="small text-muted">{formatDate(order.createdAt)}</div>
                                        <div className="small text-muted">{formatTime(order.createdAt)}</div>
                                    </div>
                                    <div className="fw-bold text-success fs-5">{formatCurrency(order.totalAmount)}</div>
                                </div>
                                <div className="d-flex justify-content-between border-top pt-2">
                                    <Button variant="light" className="flex-fill me-1 text-success" size="sm" onClick={() => { setSelectedOrder(order); setShowItemsModal(true); }}>
                                        <i className="ri-list-check-2 fs-5"></i> Items
                                    </Button>
                                    <Button variant="light" className="flex-fill mx-1 text-primary" size="sm" onClick={() => { setSelectedOrder(order); setShowDetailsModal(true); }}>
                                        <i className="ri-user-search-line fs-5"></i> Details
                                    </Button>
                                    <Button variant="light" className="flex-fill mx-1 text-warning" size="sm" onClick={() => {
                                        setEditForm({ orderId: order.orderId, status: order.status, shippingAddress: order.shippingAddress, notes: order.notes });
                                        setShowEditModal(true);
                                    }}>
                                        <i className="ri-pencil-line fs-5"></i> Edit
                                    </Button>
                                    <Button variant="light" className="flex-fill ms-1 text-danger" size="sm" onClick={() => { setOrderToCancel(order); setShowCancelModal(true); }}>
                                        <i className="ri-close-circle-line fs-5"></i>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </Container>

            <Modal show={showItemsModal} onHide={() => setShowItemsModal(false)} size="lg" centered>
                <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Items for {selectedOrder?.orderNo}</Modal.Title></Modal.Header>
                <Modal.Body className="p-0">
                    <Table responsive hover className="mb-0">
                        <thead className="bg-light small text-uppercase">
                            <tr><th className="ps-4">Product</th><th className="text-center">Price</th><th className="text-center">Qty</th><th className="text-end pe-4">Subtotal</th></tr>
                        </thead>
                        <tbody>
                            {selectedOrder?.orderItems?.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="ps-4"><strong>{item.product?.productName}</strong><br/><small className="text-muted">{item.product?.category}</small></td>
                                    <td className="text-center">{formatCurrency(item.unitPrice)}</td>
                                    <td className="text-center">x {item.quantity}</td>
                                    <td className="text-end pe-4 fw-bold text-success">{formatCurrency(item.unitPrice * item.quantity)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot className="table-light fw-bold">
                            <tr><td colSpan="3" className="text-end ps-4">Total Amount:</td><td className="text-end pe-4 text-success" style={{ fontSize: '1.2rem' }}>{formatCurrency(selectedOrder?.totalAmount)}</td></tr>
                        </tfoot>
                    </Table>
                </Modal.Body>
                <Modal.Footer className="border-0"><Button variant="secondary" onClick={() => setShowItemsModal(false)}>Close</Button></Modal.Footer>
            </Modal>

            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
                <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Customer Details</Modal.Title></Modal.Header>
                <Modal.Body className="bg-light mx-3 rounded-3 p-4">
                    <div className="mb-3"><small className="text-muted d-block fw-bold">NAME</small><strong>{selectedOrder?.customerName || selectedOrder?.user?.name}</strong></div>
                    <div className="mb-3"><small className="text-muted d-block fw-bold">EMAIL</small><strong>{selectedOrder?.user?.email || selectedOrder?.email}</strong></div>
                    <div className="mb-3"><small className="text-muted d-block fw-bold">PHONE</small><strong className="text-primary">{selectedOrder?.user?.phoneNumber || selectedOrder?.customerPhone || selectedOrder?.phoneNumber || 'N/A'}</strong></div>
                    <div className="mb-0"><small className="text-muted d-block fw-bold">SHIPPING ADDRESS</small><strong>{selectedOrder?.shippingAddress || 'N/A'}</strong></div>
                </Modal.Body>
                <Modal.Footer className="border-0"><Button variant="secondary" onClick={() => setShowDetailsModal(false)}>Close</Button></Modal.Footer>
            </Modal>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header closeButton className="border-0"><Modal.Title className="fw-bold">Update Order</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3"><Form.Label className="small fw-bold">Status</Form.Label>
                        <Form.Select value={editForm.status} onChange={e => setEditForm({...editForm, status: e.target.value})}>{defaultStatusOptions.map(s => <option key={s} value={s}>{s}</option>)}</Form.Select>
                    </Form.Group>
                    <Form.Group><Form.Label className="small fw-bold">Shipping Address</Form.Label>
                        <Form.Control as="textarea" rows={2} value={editForm.shippingAddress} onChange={e => setEditForm({...editForm, shippingAddress: e.target.value})} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="border-0"><Button variant="primary" onClick={handleSaveEdit} className="w-100" style={{ backgroundColor: THEME_COLOR }}>Save Changes</Button></Modal.Footer>
            </Modal>

            <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered>
                <Modal.Body className="text-center p-4">
                    <h5 className="text-danger fw-bold">Cancel Order?</h5>
                    <p>Are you sure you want to cancel <strong>{orderToCancel?.orderNo}</strong>?</p>
                    <div className="d-grid gap-2"><Button variant="danger" onClick={confirmCancel} disabled={btnLoading}>{btnLoading ? 'Cancelling...' : 'Confirm Cancellation'}</Button><Button variant="light" onClick={() => setShowCancelModal(false)}>Keep Order</Button></div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default AdminOrders;